<template>
  <div v-if="item.type == 'title'" class="item-title">
    <div v-if="!preview">
      <vs-dropdown  vs-custom-content vs-trigger-click class='btn-delete'>
        <vs-button
          style="cursor: pointer;"
          radius
          color="danger"
          type="flat"
          icon-pack="feather"
          icon="icon-trash"
        ></vs-button>
        <vs-dropdown-menu class="dropdown-login">
          <div class="dropdownMenu">
            <div class="d-flex" style="justify-content:space-between">
              <h3 class="mb-3">Supprimer ?</h3>
            </div>
            <vs-button
            v-if="!preview"
              style="width:100% !important;"
              @click="remove()"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-check"
              size="flat"
            ></vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <quill-editor
        v-model="item.content"
        :disabled="!contenteditable"
        :options="editorOption"
      >
        {{ item.content }}
      </quill-editor>
    </div>
    <div v-else v-html="item.content"></div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import map from "lodash/map";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  props: [
    "preview",
    "contenteditable",
    "item",
    "colIndex",
    "rowIndex",
    "layout",
    "index",
  ],
  data() {
    return {
      editorOption: {
        theme: "bubble",
        modules: {
          toolbar: [[{ header: 1 }, { header: 2 }], [{ align: [] }]],
        },
      },
      content: "",
      titleSize: "3em",
    };
  },
  methods: {
    remove() {
      var arr = this.layout[this.rowIndex].col[this.colIndex].content;
      arr.splice(this.index, 1);
    },
  },
  components: {
    quillEditor,
  },
};
</script>
